var _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecycling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C08124",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 19.7051V18.3862L16.4795 21.5973L18.3 24.8083V23.4608H20.6223C20.6223 23.4608 20.8947 23.5325 21.1527 23.0595L23.2886 19.3754C23.2886 19.3754 22.9876 19.7051 22.5432 19.7051H18.3Z",
    fill: "#835B21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0022 19.2934L18.9688 15.7714L22.2425 13.8813L23.8048 16.5874C23.8048 16.5874 24.2441 17.4875 23.8048 18.3861C23.3605 19.2951 22.6437 19.2934 22.6437 19.2934H21.0022Z",
    fill: "#835B21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4814 17.1466L13.6241 17.8049L11.7506 14.6245L8.0594 14.5991L9.227 15.2718L8.06777 17.284C8.06777 17.284 7.8697 17.4842 8.1508 17.944L10.2769 21.6338C10.2769 21.6338 10.1414 21.2083 10.3633 20.8233L12.4814 17.1466Z",
    fill: "#835B21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4897 19.6933L15.5565 19.6895L15.5601 23.4696L12.4354 23.4726C11.8642 23.4726 11.3625 23.2311 10.8769 22.5747C10.4994 22.0645 10.486 21.4347 10.6703 21.1157L11.4897 19.6933Z",
    fill: "#835B21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6252 13.3462L16.4834 14.0061L20.1745 13.9757L22.0438 10.7928L20.8771 11.467L19.7152 9.45632C19.7152 9.45632 19.6409 9.18463 19.1023 9.19792L14.8438 9.19189C14.8438 9.19189 15.2798 9.28757 15.5022 9.67234L17.6252 13.3462Z",
    fill: "#835B21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9168 11.213L13.8848 14.7358L10.6104 12.847L12.1716 10.1403C12.1716 10.1403 12.7312 9.30966 13.729 9.24038C14.7383 9.17029 15.0955 9.7917 15.0955 9.7917L15.9168 11.213Z",
    fill: "#835B21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycling);
export default __webpack_public_path__ + "static/media/Recycling.ab20dff3.svg";
export { ForwardRef as ReactComponent };